import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { UnlockedOutlineIcon } from "modules/icons";
import ModalTitle from "./modal-title";
import colors from "app/colors";
import { useOverlay } from "modules/providers/overlay-provider";

const UnlockedConversationModal = () => {
  const { closeModal } = useOverlay();

  return (
    <Modal isOpen onClose={closeModal} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack textAlign="center" spacing={4}>
            <ModalTitle
              text="Private Threads"
              icon={<UnlockedOutlineIcon boxSize={16} />}
            />
            <Text fontSize={13} color={colors.gray50}>
              This “private” setting has been removed to allow anyone with
              access to add users and groups to this thread.
            </Text>
            <HStack>
              <Button height={8} px={10} onClick={closeModal}>
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(UnlockedConversationModal);
